module.exports = __webpack_public_path__ + "static/img/muscles_bg.97502f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/muscles_bg.png
// module id = 4Vdr
// module chunks = 1